var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpirience3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.667 32.0556C41.667 30.8473 42.147 29.6886 43.0013 28.8343C43.8556 27.98 45.0143 27.5 46.2225 27.5H50.7781C51.9863 27.5 53.145 27.98 53.9994 28.8343C54.8537 29.6886 55.3337 30.8473 55.3337 32.0556C55.3337 33.2638 54.8537 34.4225 53.9994 35.2768C53.145 36.1312 51.9863 36.6111 50.7781 36.6111H46.2225C45.0143 36.6111 43.8556 36.1312 43.0013 35.2768C42.147 34.4225 41.667 33.2638 41.667 32.0556Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8293 32.3292C33.9649 31.1935 35.5052 30.5555 37.1112 30.5555H41.6668C42.4952 30.5555 43.1668 31.2271 43.1668 32.0555C43.1668 32.884 42.4952 33.5555 41.6668 33.5555H37.1112C36.3008 33.5555 35.5236 33.8775 34.9506 34.4505C34.3776 35.0235 34.0557 35.8007 34.0557 36.6111V63.9444C34.0557 64.7548 34.3776 65.532 34.9506 66.105C35.5236 66.6781 36.3008 67 37.1112 67H59.889C60.6994 67 61.4766 66.6781 62.0496 66.105C62.6226 65.532 62.9446 64.7548 62.9446 63.9444V36.6111C62.9446 35.8007 62.6226 35.0235 62.0496 34.4505C61.4766 33.8775 60.6994 33.5555 59.889 33.5555H55.3334C54.505 33.5555 53.8334 32.884 53.8334 32.0555C53.8334 31.2271 54.505 30.5555 55.3334 30.5555H59.889C61.495 30.5555 63.0353 31.1935 64.1709 32.3292C65.3066 33.4648 65.9446 35.0051 65.9446 36.6111V63.9444C65.9446 65.5505 65.3066 67.0907 64.1709 68.2264C63.0353 69.362 61.495 70 59.889 70H37.1112C35.5052 70 33.9649 69.362 32.8293 68.2264C31.6937 67.0907 31.0557 65.5505 31.0557 63.9444V36.6111C31.0557 35.0051 31.6937 33.4648 32.8293 32.3292Z",
    fill: "#008CB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7104 61.7562L58.0685 50.3982M58.0685 50.3982H50.7669M58.0685 50.3982V57.6998M49.5499 43.5023L38.1919 54.8603M38.1919 54.8603L45.4935 54.8603M38.1919 54.8603V47.5587",
    stroke: "#008CB7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirience3);
export default __webpack_public_path__ + "static/media/Expirience3.f7ba6ffa7005fc25bbbe71f487c2df5d.svg";
export { ForwardRef as ReactComponent };